import { IPackage } from '../types';

export function selectFirstPackage(packagesList: IPackage[]): IPackage[] {
  return packagesList.map((item, i) => {
    if (i === 0) {
      return { ...item, selected: true };
    }

    return item;
  });
}
